"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var namespace_1 = __importDefault(require("../namespace"));
namespace_1.default.namespace.extend('observer.clicks', function () {
    this.frameId = false; // Has to be passed
    this.init = function () {
        namespace_1.default.debug.showInfo(this.frameId + ': observer.clicks has not yet been extended. If you don\'t need it, you can ignore this.');
    };
});
